export const NON_PROJECT_ACTIVITY_ID = -1;
